<template>
    <div id="app">
        <player-summaries v-bind:playersData="playersData"></player-summaries>

        <!--<input type="text" v-model="steamid" v-on:change="updateUserData">
        <button v-on:click="getPlayerSummaries">ok</button>-->

        <owned-games v-bind:gamesData="gamesData" v-on:selectGame="changeAppId" v-bind:api="api"></owned-games>
        <achievements v-bind:achievementsData="achievementsData" v-bind:gameSchema="gameSchema" v-if="gameDataLoaded" v-bind:api="api"></achievements>
    </div>
</template>

<script>
    import PlayerSummaries from './PlayerSummaries.vue';
    import OwnedGames from './OwnedGames.vue';
    import Achievements from './PlayerGameAchievements.vue';

    export default{
        components: {
            PlayerSummaries,
            OwnedGames,
            Achievements
        },
        data() {
            return {
                steamid: null,
                appid: null,
                playersData: {},
                gamesData: {},
                achievementsData: null,
                gameSchema: null
            }
        },
        computed: {
            gameDataLoaded() {
                return (this.achievementsData != null && this.gameSchema != null);
            },
            api() {
                return (window.location.hostname == 'localhost') ? '//localhost:4001' : 'api';
            }
        },
        methods: {
            getPlayerSummaries(){
                let self = this;
                return this.axios.get(this.api + '/users',{
                        params: {
                            steamid: this.steamid
                        }
                    })
                    .then(function (response) {
//                        console.log('getPlayerSummaries');
                        self.playersData = response.data.response;

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getOwnedGames(){
                let self = this;
                return this.axios.get(this.api + '/games',{
                        params: {
                            steamid: this.steamid
                        }
                    })
                    .then(function (response) {
//                        console.log('getOwnedGames');
                        self.gamesData = response.data.response;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getAchievements(){
                let self = this;
                return this.axios.get(this.api + '/achievements',{
                    params: {
                        steamid: this.steamid,
                        appid: this.appid
                    }
                })
                    .then(function (response) {
                        self.achievementsData = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getGameSchema(){
                let self = this;
                return this.axios.get(this.api + '/schema',{
                    params: {
                        steamid: this.steamid,
                        appid: this.appid
                    }
                })
                    .then(function (response) {
                        self.gameSchema = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            changeAppId(id){
                this.achievementsData = null;
                this.gameSchema = null;
                this.appid = id;
                this.getAchievements();
                this.getGameSchema();
            },
            updateUserData(){
                this.appid = null;
                this.gamesData = {};
                this.achievementsData = null;
                this.gameSchema = null;
                this.getPlayerSummaries();
                this.getOwnedGames();
            }
        },
        created() {
            this.getPlayerSummaries();
            this.getOwnedGames();
        }
    }
</script>

<style lang="scss">
    @import "../assets/scss/variables.scss";

    html {
        box-sizing: border-box;
    }
    *, *:before, *:after {
        box-sizing: inherit;
    }
    body {
        margin: 0;
        padding: 10px;
        font-family: "Helvetica Neue", Verdana, Arial, sans-serif;
        background-color: $color-bg-mirage2;
        color: $color-text;
    }
    a {
        color: $color-text;
    }

    h1 {
        font-size: 1.5rem;
    }
    h2 {
        font-size: 1.3rem;
    }
</style>


// WEBPACK FOOTER //
// App.vue?81ab2b34